export const STORAGE_PREFIX = 'vesper_studio';

export enum StorageKeys {
    SHOW_US_DATE_TIME_FORMAT = 'showUSDateTimeFormat',
    CALENDAR_TIME_ZONE = 'calendarTimeZone',
    CALENDAR_ZOOM = 'calendarZoom',
}
